import styled from 'styled-components'

import { colors, spaces } from '@/config/global-parameters'
import { percentFormatter } from '@/helpers/formatters'

import ListVotesItemBase, {
  IListVotesItem,
} from '../CircumscriptionSection/CircumscriptionTable/ListVotesItem'

const VoteCell = ({ circumscriptionVotes, className, list, listVotes }: IListVotesItem) => (
  <VoteWrapper className={className}>
    <VoteOption1>
      <ListText>{percentFormatter.format(Number(listVotes) || 0)}</ListText>
    </VoteOption1>
    <VoteOption2>
      <ListVotesItem
        circumscriptionVotes={circumscriptionVotes}
        list={list}
        listVotes={listVotes}
      />
    </VoteOption2>
  </VoteWrapper>
)

const ListText = styled.div`
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
`

const VoteWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: ${spaces.s};
`

const VoteOption1 = styled.div`
  display: flex;
  justify-content: end;
  width: 50%;
  min-width: min-content;
`
const VoteOption2 = styled.div`
  display: flex;
  min-width: min-content;
`

export const ListVotesItem = styled(ListVotesItemBase)`
  :hover {
    > * {
      background: ${colors.colorWhite};
    }
  }
`

export default VoteCell
